// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import ServiceSlug from './ServiceSlug';

export default compose(
  connect(
    state => ({
      userId: state.profile.user.id
    }),
    dispatch => ({}),
  ),
)(ServiceSlug);
